import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import events from './events'
/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
export const webhooks = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: webhooks.url(options),
    method: 'get',
})

webhooks.definition = {
    methods: ["get","head"],
    url: '/admin/system/webhooks',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
webhooks.url = (options?: RouteQueryOptions) => {
    return webhooks.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
webhooks.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: webhooks.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
webhooks.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: webhooks.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
const webhooksForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: webhooks.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
webhooksForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: webhooks.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebhooksSpecificationController::webhooks
* @see app/Http/Controllers/WebhooksSpecificationController.php:10
* @route '/admin/system/webhooks'
*/
webhooksForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: webhooks.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

webhooks.form = webhooksForm

const system = {
    webhooks: Object.assign(webhooks, webhooks),
    events: Object.assign(events, events),
}

export default system